import React, { useEffect } from 'react';
import './contact-us.css';
import SuccessLottey from '../Common_Component/modals/succcessful-modal/SuccessLottey/SuccessLottey';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTurnUp } from '@fortawesome/free-solid-svg-icons';

const Thank_you = () => {
  useEffect(() => {
    // Google Ads conversion tracking
    window.gtag && window.gtag('event', 'conversion', {
      send_to: 'AW-17287263462/r9JpCPK6zugaEObpmrNA',
      value: 1.0,
      currency: 'INR'
    });
  }, []);

  return (
    <section className='thankyou_sec'>
      <div className='container'>
        <div className='row'>
          <div className='col-md-4 mx-auto text-center'>
            <div className='thankyou_div'>
              <div className='mb-4'>
                <SuccessLottey />
              </div>
              <h1 className='thankyou_title'>Thank You!</h1>
              <p className='thankyou_message'>Your message has been successfully sent. We will get back to you soon.</p>

              <div className='returnhome'>
                <Link to="/"><FontAwesomeIcon icon={faTurnUp} /> Go to Home</Link>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Thank_you;
